module.exports = __webpack_public_path__ + "static/IMG-20200816-WA0013-a7229f94b886f7987d969950899c41f6.jpg";